import httpClient from 'utils/httpClient';
const path='/warranty-management';
export const getFaultGroups=(params={})=>httpClient.get(`${path}/fault-groups`,{params});
export const saveFaultGroup=(code,body)=>code?httpClient.put(`${path}/fault-groups/${encodeURIComponent(code)}`,body):httpClient.post(`${path}/fault-groups`,body);
export const getWarrantyDeviceOptions=(params={})=>httpClient.get(`${path}/device-options`,{params});
export const createWarrantyDevice=body=>httpClient.post(`${path}/devices`,body);
